import { Suspense, useState } from "react";
import Loading from "../../../../../common/components/ui/loading/Loading";
import GenericTable from "../../../../../common/components/ui/table/GenericTable";
import { TableFilters, TableFiltersState } from "../../../../../common/components/ui/table/TableFilters";
import TableFooter from "../../../../../common/components/ui/table/TableFooter";
import RespondContestModal from "./RespondContestModal";
import { useGetContestMaintenance } from "../../hooks";
import { ContestMaintenanceStatus, STATUS_LABELS_CONTEST_MAINTENANCE } from "@/types/contest-maintenance.type";
import { ContestMaintenanceDetailsModal } from "../ContestMaintenanceDetailsModal";
import { COMPANIES } from "@/common/helpers/company.helpers";

const headers = {
  companyId: "Cidade",
  createdAt: "Data da Contestação",
  status: "Status",
  licensePlate: "Placa",
  productIds: "Peças Contestadas",
};

function TableContestMaintenance() {
  const [page, setPage] = useState<number>(1);
  const [filters, setFilters] = useState<TableFiltersState>({ search: "", status: [], filterColumn: "" });
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isDetailsModalOpen, setIsDetailsModalOpen] = useState(false);
  const [selectedContestId, setSelectedContestId] = useState<string | null>(null);

  const { data, isLoading } = useGetContestMaintenance({ page, filters });

  const handleRespondClick = (id: string) => {
    setSelectedContestId(id);
    setIsModalOpen(true);
  };

  const handleDetailsClick = (id: string) => {
    setSelectedContestId(id);
    setIsDetailsModalOpen(true);
  };

  const actions = [
    {
      label: "Visualizar",
      action: (data) => handleDetailsClick(data._id),
      permissions: "read:contest-maintenance",
    },
    {
      label: "Responder contestação",
      action: (data) => handleRespondClick(data._id),
      permissions: "create:contest-maintenance",
      disabled: (data) => data.status === ContestMaintenanceStatus.APPROVED
    },
  ];

  return (
    <Suspense fallback={<Loading />}>
      <div className="table-section">
        <TableFilters
          dashboardHeader="Contestações de Manutenção"
          placeholder="Digite a placa"
          statusOptions={STATUS_LABELS_CONTEST_MAINTENANCE}
          onSearch={setFilters}
          entity="contest-maintenance" tableData={data?.data || []} />

        <GenericTable
          headers={headers}
          data={data?.data || []}
          actions={actions}
          setFilters={({ orderBy }) => {
            setFilters((prevFilters) => ({
              ...prevFilters,
              orderBy,
            }));
          }}
          renders={{
            createdAt: (date) => new Date(date as Date).toLocaleDateString(),
            status: (status) => (
              <span
                className={`px-2 inline-flex text leading-5 font-semibold rounded-full ${status === ContestMaintenanceStatus.PENDING ? "bg-yellow-100 text-yellow-800" : ""
                  } ${status === ContestMaintenanceStatus.APPROVED ? "bg-green-100 text-green-800" : ""
                  } ${status === ContestMaintenanceStatus.REJECTED ? "bg-red-100 text-red-800" : ""
                  }`}>
                {STATUS_LABELS_CONTEST_MAINTENANCE[status as ContestMaintenanceStatus]}
              </span>
            ),
            productIds: (productIds) => (productIds as string[])?.length,
            companyId: (companyId) => {
              if (!companyId) {
                return "";
              }
              return COMPANIES[companyId as string]?.sigla as string
            }
          }}
          entity="contest-maintenance"
        />
        {isLoading && <Loading />}

        <TableFooter
          page={page || 1}
          totalItems={data?.totalItems || 0}
          itemsPerPage={10}
          goToPage={setPage}
        />
      </div>
      {selectedContestId && (
        <RespondContestModal
          contestId={selectedContestId}
          isOpen={isModalOpen}
          setIsOpen={setIsModalOpen}
        />
      )}
      {selectedContestId && isDetailsModalOpen && (
        <ContestMaintenanceDetailsModal
          contestMaintenanceId={selectedContestId}
          show={isDetailsModalOpen}
          onClose={() => setIsDetailsModalOpen(false)}
        />
      )}
    </Suspense>
  );
}

export default TableContestMaintenance;
